import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { cores } from '../styles/cores';
import { Btn, Campo, Input } from '../components/UI';

export function Login() {
  const { entrar, cadastrar, usuario } = useAuth();
  const navegar = useNavigate();
  const [aba, setAba] = useState('entrar');
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');

  // Só navega quando o AuthContext já tiver carregado o usuário,
  // evitando que o PrivateRoute redirecione de volta para /login
  // antes do onAuthStateChanged atualizar o estado.
  useEffect(() => {
    if (usuario) {
      navegar('/', { replace: true });
    }
  }, [usuario, navegar]);

  const [formEntrar, setFormEntrar] = useState({ email: '', senha: '' });
  const [formCadastro, setFormCadastro] = useState({
    nome: '',
    email: '',
    senha: '',
    confirmarSenha: '',
  });

  const aoEntrar = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);

    const resultado = await entrar(formEntrar.email, formEntrar.senha);

    if (!resultado.sucesso) {
      setCarregando(false);
      setErro(resultado.mensagem);
    }
    // Em caso de sucesso, mantém "carregando" até o useEffect navegar
    // assim que o AuthContext atualizar o usuário.
  };

  const aoCadastrar = async (e) => {
    e.preventDefault();
    setErro('');

    if (formCadastro.senha !== formCadastro.confirmarSenha) {
      setErro('As senhas não coincidem');
      return;
    }
    if (formCadastro.senha.length < 6) {
      setErro('A senha deve ter pelo menos 6 caracteres');
      return;
    }

    setCarregando(true);
    const resultado = await cadastrar(formCadastro.nome, formCadastro.email, formCadastro.senha);

    if (!resultado.sucesso) {
      setCarregando(false);
      setErro(resultado.mensagem);
    }
    // Em caso de sucesso, mantém "carregando" até o useEffect navegar
    // assim que o AuthContext atualizar o usuário.
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f5f4ff 0%, #ede9ff 100%)',
        padding: 16,
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: 16,
          padding: 32,
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 10px 40px rgba(83, 74, 183, 0.1)',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 24 }}>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              backgroundColor: cores.primario,
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gridTemplateRows: '1fr 1fr',
              gap: 4,
              padding: 9,
              boxSizing: 'border-box',
              marginBottom: 12,
            }}
          >
            <div style={{ backgroundColor: '#fff', borderRadius: 3 }} />
            <div style={{ backgroundColor: '#fff', borderRadius: 3 }} />
            <div style={{ backgroundColor: '#fff', borderRadius: 3 }} />
            <div style={{ backgroundColor: '#fff', borderRadius: 3 }} />
          </div>
          <h1 style={{ margin: 0, fontSize: 20, color: cores.texto }}>Sint Projetos</h1>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: cores.textoSecundario }}>
            Gestão de projetos da equipe
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            backgroundColor: '#F1EFE8',
            borderRadius: 10,
            padding: 4,
            marginBottom: 24,
          }}
        >
          {['entrar', 'cadastro'].map((nomeAba) => (
            <button
              key={nomeAba}
              onClick={() => {
                setAba(nomeAba);
                setErro('');
              }}
              style={{
                flex: 1,
                padding: '8px 0',
                border: 'none',
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
                backgroundColor: aba === nomeAba ? '#fff' : 'transparent',
                color: aba === nomeAba ? cores.texto : cores.textoSecundario,
                boxShadow: aba === nomeAba ? '0 1px 4px rgba(0,0,0,0.08)' : 'none',
                transition: 'all 0.15s ease',
              }}
            >
              {nomeAba === 'entrar' ? 'Entrar' : 'Criar conta'}
            </button>
          ))}
        </div>

        {erro && (
          <div
            style={{
              backgroundColor: '#FBE6E6',
              color: cores.erro,
              padding: '10px 12px',
              borderRadius: 8,
              fontSize: 13,
              marginBottom: 16,
            }}
          >
            {erro}
          </div>
        )}

        {aba === 'entrar' ? (
          <form onSubmit={aoEntrar}>
            <Campo label="E-mail">
              <Input
                type="email"
                required
                value={formEntrar.email}
                onChange={(e) => setFormEntrar({ ...formEntrar, email: e.target.value })}
                placeholder="seuemail@empresa.com"
              />
            </Campo>
            <Campo label="Senha">
              <Input
                type="password"
                required
                value={formEntrar.senha}
                onChange={(e) => setFormEntrar({ ...formEntrar, senha: e.target.value })}
                placeholder="••••••••"
              />
            </Campo>
            <Btn type="submit" style={{ width: '100%' }} disabled={carregando}>
              {carregando ? 'Entrando...' : 'Entrar'}
            </Btn>
          </form>
        ) : (
          <form onSubmit={aoCadastrar}>
            <Campo label="Nome completo">
              <Input
                required
                value={formCadastro.nome}
                onChange={(e) => setFormCadastro({ ...formCadastro, nome: e.target.value })}
                placeholder="Seu nome completo"
              />
            </Campo>
            <Campo label="E-mail">
              <Input
                type="email"
                required
                value={formCadastro.email}
                onChange={(e) => setFormCadastro({ ...formCadastro, email: e.target.value })}
                placeholder="seuemail@empresa.com"
              />
            </Campo>
            <Campo label="Senha">
              <Input
                type="password"
                required
                value={formCadastro.senha}
                onChange={(e) => setFormCadastro({ ...formCadastro, senha: e.target.value })}
                placeholder="••••••••"
              />
            </Campo>
            <Campo label="Confirmar senha">
              <Input
                type="password"
                required
                value={formCadastro.confirmarSenha}
                onChange={(e) =>
                  setFormCadastro({ ...formCadastro, confirmarSenha: e.target.value })
                }
                placeholder="••••••••"
              />
            </Campo>
            <Btn type="submit" style={{ width: '100%' }} disabled={carregando}>
              {carregando ? 'Criando conta...' : 'Criar conta'}
            </Btn>
          </form>
        )}
      </div>
    </div>
  );
}
